import React from 'react'

const ElementAttributesPreview = ({
    element
}) => {
    return (
    <div>
        {
            (element.type === 'leaderboard')
            ?
            <div className='element-attributes'>
                <div className='meta'>
                    <b>Player Count:</b> {element.count}
                </div>
                <div className='meta'>
                    <b>Names:</b> {
                        (element.indOrTeams === 'individuals' && element.nameDisplay === 'full')
                        ?
                        'Individual Full Names'
                        :
                        (element.indOrTeams === 'individuals' && element.nameDisplay === 'display')
                        ?
                        'Individual Display Names'
                        :
                        (element.indOrTeams === 'individuals' && element.nameDisplay === 'secret')
                        ?
                        'Individual Aliases'
                        :
                        (element.indOrTeams === 'teams')
                        ?
                        'Team Names'
                        :
                        ''
                    }
                </div>
                <div className='meta'>
                    <b>Data Displayed:</b> {
                        (!element.totals) 
                        ?
                        'No Data Displayed'
                        :
                        (element.data === 'points')
                        ?
                        'Total XP'
                        :
                        (element.dataDisplay === 'currency')
                        ?
                        'Current Currency Balance'
                        :
                        (element.dataDisplay === 'currencyTotal')
                        ?
                        'Total Currency Earned'
                        :
                        ''
                    }
                </div>   
            </div>
            :
            (element.type === 'item')
            ?
            <div className='element-attributes'>
                <div className='meta'>
                    <b>Item Type:</b> {
                        (element.opt_itemType === 'inventory')
                        ?
                        'Game Item'
                        :
                        (element.opt_itemType === 'realworld')
                        ?
                        'Real World Item'
                        :
                        (element.opt_itemType === 'collectible')
                        ?
                        'Collectible Item'
                        :
                        (element.opt_itemType === 'lottery')
                        ?
                        'Lottery Ticket'
                        :
                        (element.opt_itemType === 'contribution')
                        ?
                        'Contribution Item'
                        : ''
                    }
                </div>
            </div>
            : ''
        }
    </div>
  )
}

export default ElementAttributesPreview